import { BackBar } from '../components/Bits';

export default function About() {
  return (
    <div data-testid="about-page" className="space-y-6">
      <BackBar to="/app" title="Kembali" />
      <div className="relative overflow-hidden rounded-[20px] bg-white border border-line soft-shadow p-6">
        <div className="kawung absolute inset-0 opacity-[0.03] pointer-events-none" />
        <div className="relative">
          <span className="w-2.5 h-2.5 rotate-45 bg-terra inline-block mb-4" />
          <h1 className="font-serif text-2xl font-medium tracking-tight text-ink">Tentang SebelumSah<span className="text-terra">.</span></h1>
          <p className="mt-4 text-sm leading-relaxed text-cashmere">
            SebelumSah membantu kamu mencatat dan meninjau informasi penting sebelum mengambil keputusan. SebelumSah tidak melakukan verifikasi vendor secara independen dan tidak menjamin keamanan transaksi. Keputusan tetap berada pada kamu dan pasangan.
          </p>
        </div>
      </div>

      <div className="rounded-[20px] border border-line bg-white soft-shadow p-5 space-y-4">
        <p className="font-serif text-lg font-medium text-ink">Prinsip kami</p>
        {[
          ['Sudah Dicek', 'Status berarti kamu sendiri yang sudah mengecek — selalu dicatat dengan “Dicek oleh Anda · tanggal”.'],
          ['Perlu Dicek', 'Bukan penilaian buruk. Hanya penanda jujur bahwa sesuatu belum ditinjau.'],
          ['Langkah Berikutnya', 'SebelumSah tidak menilai, hanya membantu memprioritaskan apa yang sebaiknya dibereskan.'],
          ['Tanpa skor', 'Tidak ada trust score, persentase keamanan, atau label “terverifikasi”. Tidak ada jalan pintas untuk kepercayaan.'],
        ].map(([t, d]) => (
          <div key={t} className="border-l-2 border-terra/40 pl-4">
            <p className="text-sm font-bold text-ink">{t}</p>
            <p className="text-xs text-cashmere leading-relaxed mt-0.5">{d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
